import type { FunctionComponent } from "preact";
import { useTranslator } from "../../hooks/i18n.ts";
import { useStore } from "@nanostores/preact";
import { $isAdvanceUser } from "../../store/user_info.ts";

export type AdvanceUserRequiredBannerProps = {
    children: unknown;
};

export const AdvanceUserRequiredBanner: FunctionComponent<AdvanceUserRequiredBannerProps> = (props) => {
    const isAdvanceUser = useStore($isAdvanceUser);
    const t = useTranslator();
    if (isAdvanceUser) {
        return props.children;
    } else {
        return (
            <div style="width: 100%; height: 100%; padding: var(--pico-spacing); display: flex; justify-content: center; align-items: center;">
                {t({
                    zh: "您不是高级用户，不能使用该功能。",
                    en: "You are not advance user, this feature is disabled.",
                })}
            </div>
        );
    }
};
export default AdvanceUserRequiredBanner;
